import apiHelper from "services/apiHelper";
import useSWR from "swr";

export const getAllproductCategories = () => {
    return apiHelper(`api/v1/productCategories/get_all_categories`, "get", {}, {})
};

export const getActiveCategories = () => {
  return apiHelper(`api/v1/productCategories/get_all_active_categories`, "get", {}, {});
};

export const saveProductCategory = (id, payload) => {
    return apiHelper(id ? `api/v1/productCategories/update_category/${id}` : `api/v1/productCategories/create_category`, id ? "patch" : "post", payload, {})
}

export const deleteSingleProductCategory = (id) => {
    return apiHelper(`api/v1/productCategories/delete_category/${id}`, "delete", {}, {})
}

export function getPaginatedProductCategoryAPI({ params }) {
    return apiHelper(`api/v1/productCategories/get_all_categories?${params.query}`, "get", null, {});
  }
  
  const getproductCategoriesFetcher = async ({ url, ...params }) => {
    const searchData = await getPaginatedProductCategoryAPI({
      params,
    });
    
    
    return searchData.data.data;
  };
  
  
  const usePaginatedproductCategories = (params) => {
    return useSWR(
      params
        ? {
            url: `/api/productCategories`,
            ...params,
          }
        : null,
        getproductCategoriesFetcher,
      {
        revalidateOnFocus: false,
        dedupingInterval: 3000,
        errorRetryCount: 3,
      }
    );
  };

export default usePaginatedproductCategories;